// extracted by mini-css-extract-plugin
export default {"main":"Screens_main__84rng"};